import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedCourses from './components/FeaturedCourses';
import WhyChooseUs from './components/WhyChooseUs';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const seoTitle = '成人在线学习平台——提升职场竞争力的最佳选择';
const seoDesc = '成人在线学习是现代职场人士提升自我的高效途径。无论您是想获得专业资格证书、掌握新技能还是转型升级，我们的成人在线课程灵活便捷，随时随地学习，助您实现职业目标与个人成长。';
const seoKeywords = '成人在线,成人在线课程,成人在线教育,成人在线学习平台,在线职业技能培训,成人继续教育,在线资格证书课程,灵活在线学习';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '学至成',
  url: 'https://www.example.com/',
  description: seoDesc,
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '学至成',
  url: 'https://www.example.com/',
  description: seoDesc,
  foundingDate: '2020',
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={seoTitle}
        description={seoDesc}
        keywords={seoKeywords}
        canonicalUrl="https://www.example.com/"
        schemaData={{
          '@context': 'https://schema.org',
          '@graph': [websiteSchema, orgSchema],
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedCourses />
        <WhyChooseUs />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}